export default function (http) {
    return {
        queryByPage(data) {
            return http.json({
                url: `/customer/query`,
                data
            });
        },
        /**
         * 禁用或启用用户
         * @param data
         * @return {*}
         */
        isUse(data) {
            return http.json({
                url: `/customer/isUse?id=${data.id}&phone=${data.phone}&state=${data.state}`,
                data
            })
        },


        analysis(data) {
            return http.json({
                url: `/analysis/queryData`,
                data
            })
        },

        queryActiveByPrecinct(data) {
            return http.json({
                url: `/analysis/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },
        queryActiveListByPrecinct (data){
            return http.json({
                url: '/analysis/queryActiveListByPrecinct',
                data
            })
        },

    };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/customer.js